import React, { useState } from 'react';
import {
  Box,
  List,
  ListItemText,
  Divider,
  Tooltip,
  ListItemIcon,
  Drawer as MuiDrawer,
  ListItemButton,
  Collapse
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InfoIcon from '@mui/icons-material/Info';
import AccountTreeIcon from '@mui/icons-material/AccountTree'; // Ícone para categorias
import ArticleIcon from '@mui/icons-material/Article'; // Ícone para Documentos
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [infoOpen, setInfoOpen] = useState(true); // Estado para o menu de Informação

  const handleNavigate = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleProfileClick = () => {
    const env = process.env.NODE_ENV;
    let targetUrl = '';
  
    if (env === 'development') {
      targetUrl = `http://localhost:3000`;
    } else {
      targetUrl = `https://connect.publisol.com.br`;
    }
  
    window.open(targetUrl, '_blank');
  };

  const handleInfoClick = () => {
    setInfoOpen(!infoOpen);
  };

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  return (
    <MuiDrawer anchor="left" open={isOpen} onClose={onClose}>
      <Box sx={{ width: 250 }} role="presentation">
        <List>
          <Tooltip title="Dashboard" placement="right">
            <ListItemButton onClick={() => handleNavigate('/dashboard')}>
              <ListItemIcon>
                <DashboardIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton>
          </Tooltip>
          
          <Tooltip title="Gerenciar Publicações" placement="right">
            <ListItemButton onClick={() => handleNavigate('/publicacoes')}>
              <ListItemIcon>
                <NewspaperIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Publicações" />
            </ListItemButton>
          </Tooltip>
          
          {/* Menu Acesso à Informação com Subitens */}
          <ListItemButton onClick={handleInfoClick}>
            <ListItemIcon>
              <InfoIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Informação" />
            {infoOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={infoOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <Tooltip title="Gerenciar Documentos de Informação" placement="right">
                <ListItemButton onClick={() => handleNavigate('/informacoes')} sx={{ pl: 4 }}>
                  <ListItemIcon>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Documentos" />
                </ListItemButton>
              </Tooltip>
              <Tooltip title="Gerenciar Categorias de Informação" placement="right">
                <ListItemButton onClick={() => handleNavigate('/informacoes/categorias')} sx={{ pl: 4 }}>
                  <ListItemIcon>
                    <AccountTreeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Categorias" />
                </ListItemButton>
              </Tooltip>
            </List>
          </Collapse>

          <Divider />

          <Tooltip title="Gerenciar seu perfil." placement="right">
            <ListItemButton onClick={handleProfileClick}>
              <ListItemIcon>
                <AccountCircle color="primary" />
              </ListItemIcon>
              <ListItemText primary="Perfil" />
            </ListItemButton>
          </Tooltip>
          <Tooltip title="Desconectar sua conta Publisol." placement="right">
            <ListItemButton onClick={handleSignOut}>
              <ListItemIcon>
                <LogoutIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Desconectar" />
            </ListItemButton>
          </Tooltip>
        </List>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;
